module.exports = __webpack_public_path__ + "static/media/bowling-ball.4411d3b1.svg";